export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'x-large'
}

export enum ButtonColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary'
}

export enum ButtonType {
  TEXT = 'text',
  PREPEND = 'prepend',
  APPEND = 'append'
}

export enum IconButtonColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary'
}

export enum IconButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'x-large',
  XXLARGE = 'xx-large'
}
export enum IconButtonShape {
  CIRCLE = 'circle',
  SQUARE = 'square'
}

export enum TooltipPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  START = 'start',
  END = 'end'
}

export enum TooltipColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export enum CheckboxColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export enum SnackbarType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  REGULAR = 'regular',
  CLOSE = 'close'
}
